import { Switch, withStyles } from '@material-ui/core';

export const GreenSwitch = withStyles((theme) => ({
  colorSecondary: {
    '&.Mui-checked': {
      color: theme.palette.success.main,
    },
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.success.main,
    },
  },
}))(Switch);
